import {
  ADD_APPLESMSFIX_SUCCESS,
  DELETE_APPLESMSFIX_SUCCESS,
  GET_APPLESMSFIX_FAIL,
  GET_APPLESMSFIX_SUCCESS,
  UPDATE_APPLESMSFIX_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  applesmsfix: [],
  total: 0,
  pagination: { page: 1, per_page: 10, search: "" },
  error: {},
};

const APPLESMSFIX = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_APPLESMSFIX_SUCCESS:
      return {
        ...state,
        applesmsfix: action.payload.applesmsfix,
        total: action.payload.total ?? state.total,
        pagination: {
          page: action.payload.page ?? state.pagination.page,
          per_page: action.payload.per_page ?? state.pagination.per_page,
          search: action.payload.search ?? state.pagination.search,
        },
      };

    case GET_APPLESMSFIX_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_APPLESMSFIX_SUCCESS:
      return {
        ...state,
        applesmsfix: [...state.applesmsfix, action.payload],
      };

    case UPDATE_APPLESMSFIX_SUCCESS:
      return {
        ...state,
        applesmsfix: state.applesmsfix.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
      };

    case DELETE_APPLESMSFIX_SUCCESS:
      return {
        ...state,
        applesmsfix: state.applesmsfix.filter((id) => id.id !== action.payload),
      };

    default:
      return state;
  }
};

export default APPLESMSFIX;
